import React, { memo } from 'react';
import MaskedInput from 'react-text-mask';
import {
    Grid,
    Box,
    Typography,
    InputLabel,
    Input,
    Button,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import { hmsToSecondsOnly } from './utils/Time';

interface IProps {
    setTrimTime: (startTrim: number, endTrim: number) => void;
    isRendering: boolean;
}

interface TextMaskCustomProps {
    inputRef: (ref: HTMLInputElement | null) => void;
}

function TextMaskCustom(props: TextMaskCustomProps) {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={(ref: any) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={[
                /[0-9]/,
                /[0-9]/,
                ':',
                // ' ',
                /[0-9]/,
                /[0-9]/,
                ':',
                // ' ',
                /[0-9]/,
                /[0-9]/,
            ]}
            placeholderChar={'\u2000'}
            showMask
        />
    );
}

export default memo(function VideoAction({ setTrimTime, isRendering }: IProps) {
    const [startLength, setStartLength] = React.useState<string>('00:00:00');
    const [endLength, setEndLength] = React.useState<string>('00:00:00');
    const [error, setError] = React.useState<string>('');

    const handleChangeStartLength = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setStartLength(event.target.value);
    };

    const handleChangeEndLength = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setEndLength(event.target.value);
    };

    const handleApplyBtn = () => {
        // Invalid input
        if (
            startLength !== '00:00:00' &&
            hmsToSecondsOnly(startLength) === null
        ) {
            return setError('Invalid start time!!!');
        }
        if (endLength !== '00:00:00' && hmsToSecondsOnly(endLength) === null) {
            return setError('Invalid end time!!!');
        }

        const secondStartTime = hmsToSecondsOnly(startLength);
        const secondEndTime = hmsToSecondsOnly(endLength);

        // Invalid start time and end time
        if (
            secondStartTime !== null &&
            secondEndTime !== null &&
            secondStartTime > 0 &&
            secondEndTime > 0 &&
            secondStartTime >= secondEndTime
        ) {
            return setError('Invalid second start time and end time');
        }

        setError('');
        setTrimTime(secondStartTime as number, secondEndTime as number);
    };

    const handleRemoveBtn = () => {
        setStartLength('00:00:00');
        setEndLength('00:00:00');
        setTrimTime(0, 0);
    };

    return (
        <Grid item xs={12}>
            <Box display='flex' flexDirection='column' justifyContent='center'>
                <Typography align='center' variant='body2'>
                    Trim Video ( format hour:minute:second, eg: Video have duration 3 second will be: 00:00:03)
                </Typography>

                {error !== '' && (
                    <Box display='flex' justifyContent='center' m={1}>
                        <Alert severity='error'>{error}</Alert>
                    </Box>
                )}

                <Box display='flex' justifyContent='center' m={1}>
                    <InputLabel
                        style={{ margin: 10 }}
                        htmlFor='formatted-text-mask-input'
                    >
                        Start From
                    </InputLabel>
                    <Input
                        value={startLength}
                        onChange={handleChangeStartLength}
                        inputComponent={TextMaskCustom as any}
                    />
                </Box>

                <Box display='flex' justifyContent='center' m={1}>
                    <InputLabel
                        style={{ margin: 10 }}
                        htmlFor='formatted-text-mask-input'
                    >
                        End At
                    </InputLabel>
                    <Input
                        value={endLength}
                        onChange={handleChangeEndLength}
                        inputComponent={TextMaskCustom as any}
                    />
                </Box>

                <Box display='flex' justifyContent='center' m={5}>
                    <Button
                        disabled={isRendering}
                        onClick={handleApplyBtn}
                        variant='outlined'
                        color='secondary'
                        style={{ margin: 3 }}
                    >
                        Apply Trim Video Effect
                    </Button>

                    <Button
                        disabled={isRendering}
                        onClick={handleRemoveBtn}
                        variant='outlined'
                        color='primary'
                        style={{ margin: 3 }}
                    >
                        Remove Trim Video Effect
                    </Button>
                </Box>
            </Box>
        </Grid>
    );
});
